/**
 * One-time migration of localStorage keys from the legacy "itech_" prefix to
 * "primecontrol_". Runs before the app bootstraps so existing sessions
 * (access token, instance, preferences) survive the rename.
 *
 * Safe to remove once no clients have pre-rename localStorage left
 * (the migration is idempotent and a no-op when nothing matches).
 */
const LEGACY_PREFIX = 'itech_';
const CURRENT_PREFIX = 'primecontrol_';

export function migrateLegacyStorageKeys(): void {
  try {
    const legacyKeys: string[] = [];
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      if (key?.startsWith(LEGACY_PREFIX)) {
        legacyKeys.push(key);
      }
    }

    for (const legacyKey of legacyKeys) {
      const newKey = CURRENT_PREFIX + legacyKey.slice(LEGACY_PREFIX.length);
      // Never overwrite a value already written under the new key
      if (localStorage.getItem(newKey) === null) {
        const value = localStorage.getItem(legacyKey);
        if (value !== null) {
          localStorage.setItem(newKey, value);
        }
      }
      localStorage.removeItem(legacyKey);
    }
  } catch {
    // localStorage unavailable (SSR/privacy mode) — nothing to migrate
  }
}
